var ImgLazyLoad = new Class({
	Implements: [Options,Events],

	options: {
		range: 200,
		empty_image: Res_i + '/l/dummy.png',
		elements: 'img._lazy',
		container: document.body
	},

	initialize: function(options){
		var self = this;

		this.setOptions(options);
		this._container = $(this.options.container);

		if(!this._container) return;

		this.container_height = this._container.getSize().y;

		this._elements = this._container.getElements(this.options.elements);

		this._elements.each(function(_el) {
			if(_el.get('tag') != 'img') return;

			_el._cont = new Element('span', {
				'class': 'w_imglazyload'
			});

			_el._cont.inject(_el, 'before');

			_el._cont.adopt(_el);
		});

		this.initial_filtering();

		window.addEvents({
			'scroll': function(){
				self.check_position();
			}
		});
	},

	initial_filtering: function(){
		var self = this;

		this._elements = this._elements.filter(function(_el){
			if((document.body.getScroll().y + window.getSize().y + self.options.range) >= _el.getPosition().y){
				if(_el.get('tag') == 'img'){
					self.display_image(_el);
				}else{
					_el.getElements('img').each(function(_e){
						self.display_image(_e);
					});
				}
			}else{
				if(_el.get('tag') == 'img'){
					self.hold_image(_el);
				}else{
					_el.getElements('img').each(function(_e){
						self.hold_image(_e);
					});
				}

				return true;
			}
		}, this);
	},

	hold_image: function(_el){
		var src = _el.get('src') || _el.getAttribute('data-src');

		if(src && src != ''){
			_el.setAttribute('data-src', src);
		}

		_el.set('src', this.options.empty_image);
	},

	display_image: function(_el){
		if(_el.get('tag') == 'img'){
			this.set_image(_el);
		}else{
			_el.getElements('img').each(function(_e){
				this.set_image(_e);
			}.bind(this));
		}
	},

	set_image: function(_el){
		var src = _el.getAttribute('data-src');

		new Asset.image(src, {
			onLoad: function(){
				_el.set('src', src);

				if(_el._cont){
					_el.inject(_el._cont, 'after');
					_el._cont.dispose();
				}
			}
		});
	},

	check_position: function(){
		var self = this;

		this._elements = this._elements.filter(function(_el, i){
			if((document.body.getScroll().y + window.getSize().y + self.options.range) >= _el.getPosition().y){
				if(_el.get('tag') == 'img'){
					self.display_image(_el);
				}else{
					_el.getElements('img').each(function(_e){
						self.display_image(_e);
					});
				}

				return false;
			}

			return true;
		});

		if(this._elements.length == 0){
			this._container.removeEvent('scroll', this.check_position.bind(this));
		}
	}
});
